import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/school-wx-users";

export default createStore({ Model });
